import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold text-gray-900 px-1 truncate" }
const _hoisted_2 = {
  key: 0,
  class: "ml-6"
}
const _hoisted_3 = {
  key: 1,
  class: "px-2 text-gray-400 text-xs py-1 ml-6"
}
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col ml-4"
}

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Organization } from "shared/types/Organization";
import { Project } from "shared/types/Project";
import OrganizationTabProjectsHierarchyItem from "@/views/organizations/components/OrganizationTabProjectsHierarchyItem.vue";
import OrganizationTabProjectsItem from "@/views/organizations/components/OrganizationTabProjectsItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabProjectsHierarchyItem',
  props: {
    organization: {},
    organizationsByParentId: {},
    projectsByCustomerNameSiteId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const children = computed(() => {
  const items = props.organizationsByParentId[props.organization._id] || [];
  return items.slice().sort((a, b) => a.name.localeCompare(b.name));
});

const projectKeys = computed(() =>
  props.organization.explicit_projects
    .map((project) => `${project.customer_name}_${project.site_id}`)
    .filter((projectKey) => props.projectsByCustomerNameSiteId[projectKey]),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Disclosure), { defaultOpen: true }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(DisclosureButton), { class: "flex items-center py-1 pl-2 pr-1.5" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronRightIcon), {
            class: _normalizeClass([{ 'rotate-90': open }, "w-5 h-5 shrink-0"])
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.organization.name), 1)
        ]),
        _: 2
      }, 1024),
      _createVNode(_unref(DisclosurePanel), null, {
        default: _withCtx(() => [
          (projectKeys.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectKeys.value, (projectKey) => {
                  return (_openBlock(), _createBlock(OrganizationTabProjectsItem, {
                    key: projectKey,
                    project: _ctx.projectsByCustomerNameSiteId[projectKey] as Project,
                    organization: _ctx.organization
                  }, null, 8, ["project", "organization"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (children.value.length === 0 && projectKeys.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("organizations.no_projects")), 1))
            : _createCommentVNode("", true),
          (children.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.value, (childOrganization) => {
                  return (_openBlock(), _createBlock(OrganizationTabProjectsHierarchyItem, {
                    key: childOrganization._id,
                    organization: childOrganization,
                    organizationsByParentId: _ctx.organizationsByParentId,
                    projectsByCustomerNameSiteId: _ctx.projectsByCustomerNameSiteId
                  }, null, 8, ["organization", "organizationsByParentId", "projectsByCustomerNameSiteId"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})